import React, { useEffect, useState, useRef } from 'react'
import UserName from '../../common/user/UserName'
import SearchInput from '../../common/search-input/SearchInput';
import { useDebounce } from '../../../utils/useDebounce';
import CustModal from '../../common/custmodal/CustModal';
import Toast from '../../common/toast/Toast';
import Pagination from '../../common/pagination/pagination';
import styles from '../VendorsAppointments/VendorAppointments.module.css'
import Button from '../../common/button/Button';
import PlusIcon from '../../svgIcons/PlusIcon';
import AddVendor from '../addVendors/AddVendor';
import AddVendorsAppointment from '../addVendors/AddVendorsAppointment';
import VendorAppointmentsTable from './components/VendorAppointmentsTable';
import VendorsTable from './components/VendorsTable';
import SlidingTabs from '../../SlidingTabs/SlidingTabs';
import useWindowDimension from '../../../hooks/useWindowdimension';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/rootReducer';
import { getVendor } from '../../../redux/vendor/actions/vendors.action';
import { getVendorAppointment } from '../../../redux/vendor/actions/vendor.action';

const tabs = [
    { label: "Appointments" },
    { label: "Vendors" }
]

const VendorAppointments = () => {
    const dispatch: AppDispatch = useDispatch();
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [pageNumber, setPageNumber] = useState<number>(1);
    const searchWithDebounce = useDebounce(searchTerm, 1000, setPageNumber);
    const [totalCount, setTotalCount] = useState(0);
    const pageLimit = 10;
    const [activeTab, setActiveTab] = useState<number>(0);
    const [showModal, setShowModal] = useState(false);
    const windowWidth = useWindowDimension();

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    // Function to refetch data based on active tab
    const refetchCurrentTabData = () => {
        if (activeTab === 0) {
            dispatch(getVendorAppointment({ search: searchTerm, page: pageNumber, limit: pageLimit, setTotalCount }));
        } else {
            dispatch(getVendor({ search: searchTerm, page: pageNumber, limit: pageLimit, setTotalCount }));
        }
    };

    return (
        <>
            {showToast && <Toast type={toastType} message={toastMessage} />}

            <CustModal
                open={showModal}
                setOpen={setShowModal}
                bodyData={
                    activeTab === 0 ? (
                        <AddVendorsAppointment
                            setOpen={setShowModal}
                            setShowToast={setShowToast}
                            setToastMessage={setToastMessage}
                            setToastType={setToastType}
                            onSuccess={() => {
                                setShowModal(false);
                                refetchCurrentTabData();
                            }}
                        />
                    ) : (
                        <AddVendor
                            setOpen={setShowModal}
                            setShowToast={setShowToast}
                            setToastType={setToastType}
                            setToastMessage={setToastMessage}
                            getVendorListData={() => {
                                setShowModal(false);
                                refetchCurrentTabData();
                            }}
                        />
                    )
                }
            />

            <div className={styles.vendorAppointmentsPageContainer}>
                <div className={styles.vendorAppointmentsPageHeader}>
                    <div className={styles.vendorAppointmentsLeftContainer}>
                        <p className={styles.vendorAppointmentsUserGreet}>
                            Welcome, <UserName />
                        </p>
                        <h3>{activeTab === 0 ? `Vendor Appointments` : 'Vendors'}</h3>
                        <div className={styles.tab}>
                            <SlidingTabs tabs={tabs} onChange={(index: number) => setActiveTab(index)} />
                        </div>

                    </div>

                    <div className={styles.rightContainer}>
                        <SearchInput
                            value={searchTerm}
                            placeholder={"Search Vendor Name/Email"}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: windowWidth > 1280 ? 264 : 240 }}
                        />
                        <Button variant='green' onClick={() => setShowModal(true)} className={styles.customBtn} >
                            <PlusIcon />
                            <span>{activeTab === 0 ? `Create Vendor Appointment` : `Add Vendor`}</span>
                        </Button>
                    </div>
                </div>

                <div className={styles.vendorAppointmentsTableContainer}>
                    {activeTab === 0 && (
                        <VendorAppointmentsTable
                            searchTerm={searchWithDebounce}
                            pageNumber={pageNumber}
                            pageLimit={pageLimit}
                            totalCount={totalCount}
                            setTotalCount={setTotalCount}
                            onPageChange={setPageNumber}
                            setShowToast={setShowToast}
                            setToastMessage={setToastMessage}
                            setToastType={setToastType}
                        />
                    )}

                    {activeTab === 1 && (
                        <VendorsTable
                            searchTerm={searchWithDebounce}
                            pageNumber={pageNumber}
                            pageLimit={pageLimit}
                            totalCount={totalCount}
                            setTotalCount={setTotalCount}
                            onPageChange={setPageNumber}
                            setShowToast={setShowToast}
                            setToastMessage={setToastMessage}
                            setToastType={setToastType}
                        />
                    )}

                    <div>
                        <Pagination
                            className="pagination-bar"
                            currentPage={pageNumber}
                            totalCount={Math.ceil(totalCount / pageLimit)}
                            pageSize={1}
                            onPageChange={(page: number) => {
                                setPageNumber(page);
                            }}
                        />
                    </div>
                </div>
            </div >
        </>
    );
}

export default VendorAppointments
